import { Sounds } from "../../types/Enum";
import { ButtonBounds } from "../../types/Interface";
import BaseButton from "./BaseButton";


export default class AutoExplodeButton extends BaseButton {
  constructor(Bounds: ButtonBounds) {
    super("auto_explode", Sounds.click2, false);
    Object.assign(this, Bounds);
    this.setVisible(false);
    this.on("mouseup", () => this.handleMouseUp());
    this.on("touchend", () => this.handleMouseUp());
    this.EventBus.on(this.EnumEventBus.setTgleMlAndAutoBut, v => this.setVisible(Boolean(v)))
  }
  handlePress(): void {
    this.EventBus.emit(this.EnumEventBus.setManuelExplode, false);
  }
  handleMouseUp() {
    this.EventBus.emit(this.EnumEventBus.setTgleMlAndAutoBut, false);
  }
  setVisible(v: boolean) {
    this.visible = v;
  }
}
